import { css, cx } from 'linaria';
import { cssTheme, Colorway } from '@uds/theme-utils';
import { BreakpointProps } from '@ux/responsive';
import { Alignment } from 'domain/constants/alignment';
import { Layout } from 'domain/constants/layout';
import findResponsiveItem from 'presentation/utils/findResponsiveItem';

interface Props {
  breakpoints: BreakpointProps;
  colorway: Colorway;
  layout: Layout;
}

const tiers = css`
  display: flex;
  border-bottom: 2px solid rgba(var(--tiers-border-color), 0.2);
  overflow-x: auto;
  overflow-y: hidden;

  &::-webkit-scrollbar {
    display: none; /*    Chrome     */
    -ms-overflow-style: none; /* IE and Edge   */
    scrollbar-width: none; /*    Firefox    */
  }
`;

const link = css`
  padding-right: ${cssTheme.gu3};
  padding-left: ${cssTheme.gu3};
  margin-right: ${cssTheme.gu1};
  margin-bottom: -2px;
  flex: 0 0 auto;
`;

const centeredLink = css`
  &.${link}:first-child {
    margin-left: auto;
  }

  &.${link}:last-child {
    margin-right: auto;
  }
`;

const tiersBorderBottomColor: Record<Colorway, string> = {
  LIGHT: css`
    --tiers-border-color: ${cssTheme.palette.rgb.grey06};
  `,
  NEUTRAL: css`
    --tiers-border-color: ${cssTheme.palette.rgb.grey06};
  `,
  DARK: css`
    --tiers-border-color: ${cssTheme.palette.rgb.grey06};
  `,
  PRIMARY: css`
    --tiers-border-color: ${cssTheme.palette.rgb.primaryContrast};
  `,
  PRIMARY_GRADIENT: css`
    --tiers-border-color: ${cssTheme.palette.rgb.primaryContrast};
  `,
  HIGHLIGHT: css`
    --tiers-border-color: ${cssTheme.palette.rgb.highlightContrast};
  `,
};

const justifyContent = css`
  justify-content: flex-start;
`;

export const getClassNames = ({ breakpoints, colorway, layout }: Props) => {
  const alignment = findResponsiveItem(breakpoints, [
    layout?.alignmentMobile ?? Alignment.STARTING,
    layout?.alignmentTablet ?? Alignment.STARTING,
    layout?.alignment ?? Alignment.STARTING,
  ]);

  return {
    root: {},
    tiers: cx(tiers, tiersBorderBottomColor[colorway], alignment === Alignment.STARTING && justifyContent),
    link: cx(link, alignment === Alignment.CENTER && centeredLink),
  };
};
